module.exports = __webpack_public_path__ + "static/sport/bg.f0fb979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/bg.jpg
// module id = XGvb
// module chunks = 0